class upsaleComponent extends HTMLElement {
  constructor() {
    super();

    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    const productId = this.dataset.productId;
    const addToCartBtn = this.querySelector('[data-upsale-button]');
  
    addToCartBtn.addEventListener('click', (e) => {
      e.preventDefault();

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];  

      const formData = new FormData();
      formData.append('id', productId);
      formData.append('quantity', 1);

        if (this.cart) {
          formData.append(
            'sections',
            // this is smart AF:
            // reference to the cart-drawer.js class component and call the class methods directly
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          });

    })
  }
}

customElements.define('upsale-component', upsaleComponent);